module.exports = __webpack_public_path__ + "images/2-en.0b16c296f2c0a2ad10e41f7426d81611.jpg";